import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./Redux/Store";
import reportWebVitals from "./reportWebVitals";
import { initSentry } from "./config/sentry";

// import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import 'formiojs/dist/formio.full.min.css';
import 'bootstrap/dist/css/bootstrap.min.css'

// import "./Layouts/Public/Layout.css";
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
reportWebVitals();
